var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\xAA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M43.584 7.48801H49.6C49.472 9.02401 49.408 10.88 49.408 13.056V23.36C49.408 38.784 47.36 43.84 42.688 49.28C38.592 54.272 32.192 57.088 27.52 58.688L23.296 54.272C29.184 52.736 34.624 50.24 38.592 45.696C43.136 40.448 43.968 35.2 43.968 23.168V13.056C43.968 10.88 43.776 9.02401 43.584 7.48801Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M46.5 7.5C46.5 29 46.5 36.5 44.5 41.5C40.5 51.5 31 54 24.5 57",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M19.904 8H14.08C14.272 9.216 14.336 11.456 14.336 12.544C14.336 14.464 14.336 31.168 14.336 33.92C14.336 35.776 14.208 37.824 14.08 38.848H19.904C19.776 37.696 19.712 35.584 19.712 33.92C19.712 31.232 19.712 14.464 19.712 12.544C19.712 11.072 19.776 9.216 19.904 8Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M17 8V39",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi);
export default __webpack_public_path__ + "static/media/ri.8bd58632cf6e336f7e45a2474fbfb54b.svg";
export { ForwardRef as ReactComponent };